namespace Bookhus.Localization {
    export class Calendar {
        private translations: any = {
            book: {
                da: "Book",
                "en-GB": "Book",
                de: "Buchen",
                sv: "Boka",
                no: "Bestill"
            },
            moreInfo: {
                da: "Mere info",
                "en-GB": "More info",
                de: "Weitere Infos",
                sv: "Mer info",
                no: "Mer informasjon"
            },
            pickMonth: {
                da: "Vælg måned",
                "en-GB": "Select month",
                de: "Monat auswählen",
                sv: "Välj månad",
                no: "Velg måned"
            },
            handle: {
                da: "Håndter",
                "en-GB": "Handle",
                de: "Handle",
                sv: "Handle",
                no: "Åpen"
            },
            handleBookings: {
                da: "Håndter bookinger for",
                "en-GB": "Manage bookings for",
                de: "Buchungen verwalten für",
                sv: "Hantera bokningar för",
                no: "Administrer bestillinger for"
            },
            open: {
                da: "Åben",
                "en-GB": "Open",
                de: "Offen",
                sv: "Öppen",
                no: "Åpen"
            },
            externalHouses: {
                da: "Eksterne ferieboliger",
                "en-GB": "External holiday homes",
                de: "Externe ferienhäuser",
                sv: "Externa fritidshus",
                no: "Eksterne fritidsboliger"
            },
            show: {
                da: "Vis",
                "en-GB": "Show",
                de: "Zeige",
                sv: "Visa",
                no: "Vis"
            },
            clickForMoreInformation: {
                da: "Klik for mere info",
                "en-GB": "Click for more info",
                de: "Klicken Sie für weitere Informationen",
                sv: "Klicka för mer info",
                no: "Klikk for mer info"
            },
            clickToSelectDate: {
                da: "Klik for at vælge datoen",
                "en-GB": "Click to select the date",
                de: "Klicken Sie, um das Datum auszuwählen",
                sv: "Klicka för att välja datum",
                no: "Klikk for å velge dato"
            },
            periodIsLocked: {
                da: "Periode er låst",
                "en-GB": "Period is locked",
                de: "Zeitraum ist gesperrt.",
                sv: "Perioden är låst.",
                no: "Perioden er låst."
            },



            noTranslation: {
                da: "Oversættelse findes ikke",
                "en-GB": "Translation does not exist",
                de: "Übersetzung existiert nicht",
                sv: "Översättning finns inte",
                no: "Oversettelse finnes ikke"
            }
        }

        get(name: string, lang?: string): string {
            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            if (this.translations.hasOwnProperty(name)) {
                var value = this.translations[name][langCode] || this.translations[name]["da"];
                if (value && value.constructor !== Array) {
                    return value;
                }
            }

            var regionalValue = $.datepicker.regional[langCode][name] || $.datepicker.regional['da'][name];
            if (regionalValue && regionalValue.constructor !== Array) {
                return regionalValue;
            }

            return this.translations['noTranslation'][langCode] || this.translations['noTranslation']['da'] ||  "Oversættelse findes ikke";
        }

        getValues(name: string, lang?: string): string[] {
            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            if (this.translations.hasOwnProperty(name)) {
                var value = this.translations[name][langCode] || this.translations[name]["da"];
                if (value && value.constructor === Array) {
                    return value;
                }
            }

            var regionalValue = $.datepicker.regional[langCode][name] || $.datepicker.regional['da'][name];
            if (regionalValue && regionalValue.constructor === Array) {
                return regionalValue;
            }

            return null;
        }
    }
}